import { MobileFriendlyFormDropdown } from 'components/MobileFriendlyDropdown';
import React, { useContext } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { defineMessages, useIntl } from 'react-intl';
import { Form, Grid } from 'semantic-ui-react';
import {
  EntryFormContext,
  EntryFormContextType,
  EntryFormValues,
} from './EntryForm';

const m = defineMessages({
  problematics: {
    id: 'Entry.Form.Problematics',
    defaultMessage: 'Préoccupations, problématiques ou sujets abordés',
  },
});

interface Props {
  isMobile: boolean;
}

export const ProblematicsForm: React.FC<Props> = ({ isMobile }) => {
  const { formatMessage } = useIntl();

  const { lists } = useContext(EntryFormContext) as EntryFormContextType;

  const { control } = useFormContext<EntryFormValues>();

  return (
    <Grid columns={2} doubling>
      <Grid.Column>
        <Form.Field>
          <label>{formatMessage(m.problematics)}</label>
          <Controller
            control={control}
            name="problematicIds"
            render={({ field: { value, onChange } }) => (
              <MobileFriendlyFormDropdown
                fluid
                multiple
                search
                selection
                options={lists?.problematics.dropdownItems}
                value={value}
                onChange={(e, data) => onChange(data.value)}
                isMobile={isMobile}
              />
            )}
          />
        </Form.Field>
      </Grid.Column>
    </Grid>
  );
};
